// extracted by mini-css-extract-plugin
module.exports = {"container":"_249862a5","narrow":"_96323abd"};